import { Button as DialogButton, Field } from '@/ui'
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './EmployerDecline.module.scss'
import CloseButton from '@/components/CloseButton/CloseButton'
import { useDispatch, useSelector } from 'react-redux'
import { eColContractsSelectors, eColContractsThunks } from '@/entity'

export const EmployerDecline = ({ onClose, externalId, isOpen, handleCloseDecline }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const isSuccessContract = useSelector(eColContractsSelectors.isSuccessContract)
	const [note, setNote] = useState('')

	useEffect(() => {
		if (isSuccessContract) {
			onClose()
		}
	}, [isSuccessContract])

	const handleSign = () => {
		dispatch(eColContractsThunks.declineEmployer(externalId, note))
	}

	return (
		<Dialog classes={{ paper: styles.dialog }} onClose={onClose} open={isOpen}>
			<Box>{onClose ? <CloseButton onClose={onClose}></CloseButton> : null}</Box>
			<DialogTitle classes={{ root: styles.sign__title }}>{t('col_contract.title_decline')}</DialogTitle>
			<DialogContent sx={{ paddingBottom: '40px' }}>
				<div className={styles.dialog__buttons__wrapper}>
					<Field
						value={note}
						onChange={(e) => {
							setNote(e)
						}}
						wrapperClassName={styles.textarea__wrapper}
						placeholder={t('el_cause_short')}
						rows={8}
						fieldType="textarea"
					/>
					<div className={styles.reset__button__wrapper}>
						<DialogButton type="button" onClick={handleSign} disabled={!note}>
							{t('decline')}
						</DialogButton>
					</div>
					<Button
						type="button"
						variant="text"
						classes={{ root: cn(styles.button, styles.reset__button, styles.reset__button) }}
						onClick={handleCloseDecline}
					>
						{t('cancel')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
